// This dummy URL is updated by a deploy script based on the environment. E.g.
// when deploying to production, CI replaces secure.checkout.visa.com with
// secure.checkout.visa.com, but when deploying to cert, it will be
// cert.secure.checkout.visa.com.
export const STATIC_ROOT_DOMAIN = 'https://secure.checkout.visa.com';
